/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    type: NotificationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    body: string;
    /**
     * 
     * @type {any}
     * @memberof NotificationDto
     */
    data: any;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    isRead: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NotificationDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof NotificationDto
     */
    updatedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationDtoTypeEnum {
    ORDERCONFIRMATION = 'ORDER_CONFIRMATION',
    PAYMENTFAILED = 'PAYMENT_FAILED',
    ORDERSHIPPED = 'ORDER_SHIPPED',
    ORDERDELIVERED = 'ORDER_DELIVERED',
    REFUNDPROCESSED = 'REFUND_PROCESSED',
    REVIEWREPLY = 'REVIEW_REPLY',
    ABANDONEDCARTREMINDER = 'ABANDONED_CART_REMINDER',
    PRICEDROPALERT = 'PRICE_DROP_ALERT',
    BACKINSTOCK = 'BACK_IN_STOCK',
    PASSWORDRESET = 'PASSWORD_RESET',
    NEWDEVICELOGIN = 'NEW_DEVICE_LOGIN',
    TWOFACODE = 'TWO_FA_CODE',
    NEWORDER = 'NEW_ORDER',
    LOWSTOCKWARNING = 'LOW_STOCK_WARNING',
    NEWRETURNREQUEST = 'NEW_RETURN_REQUEST',
    NEWUSERREGISTERED = 'NEW_USER_REGISTERED',
    HIGHVALUEORDERALERT = 'HIGH_VALUE_ORDER_ALERT',
    PAYOUTFAILED = 'PAYOUT_FAILED',
    ORDERSTATUSUPDATED = 'ORDER_STATUS_UPDATED',
    INVOICEPAYMENTREQUIRED = 'INVOICE_PAYMENT_REQUIRED'
}

